/* LoveLEDLights Premium FX: Licht-an-Effekte fuer die lllp-Sections */
(function(){
  if(!('IntersectionObserver' in window))return;
  var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('lllp-js');

  /* Ueberschriften und Sections einschalten, sobald sie ins Bild kommen */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var t=e.target;
    if(t.classList.contains('lllp-h2'))t.classList.add('lit');
    if(t.classList.contains('rv-wait')){t.classList.remove('rv-wait');t.classList.add('rv-in')}
    io.unobserve(t)})},{threshold:.25});

  /* Karten leuchten, wenn sie in der Bildmitte sind (vor allem Handy) */
  var mid=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('on',e.isIntersecting)})},{rootMargin:'-38% 0px -38% 0px'});

  function tilt(card){
    if(card.dataset.tilt||!matchMedia('(hover:hover)').matches||RM)return;card.dataset.tilt=1;
    var ph=card.querySelector('.ph');if(!ph)return;
    card.addEventListener('pointermove',function(e){var r=ph.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;ph.style.setProperty('--rx',(x*10).toFixed(2)+'deg');ph.style.setProperty('--ry',(-y*10).toFixed(2)+'deg')});
    card.addEventListener('pointerleave',function(){ph.style.setProperty('--rx','0deg');ph.style.setProperty('--ry','0deg')});
  }

  /* Bilder in Wischleisten erst laden, wenn sie ins Bild kommen; Rollover-Bilder nur mit Maus */
  var touch=matchMedia('(hover:none)').matches;
  var lz=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var i=e.target;if(i.dataset.lzSrcset)i.srcset=i.dataset.lzSrcset;i.src=i.dataset.lzSrc;i.removeAttribute('data-lz-src');lz.unobserve(i)})},{rootMargin:'400px 200px'});

  /* Absicherung: nach dem Laden der Seite alle restlichen Bilder holen, damit keine Kachel leer bleibt */
  function lzAll(){[].forEach.call(document.querySelectorAll('img[data-lz-src]'),function(i){if(touch&&i.classList.contains('b'))return;if(i.dataset.lzSrcset)i.srcset=i.dataset.lzSrcset;i.src=i.dataset.lzSrc;i.removeAttribute('data-lz-src')})}
  addEventListener('load',function(){setTimeout(lzAll,2000)});

  /* Kundenfotos: 8 sofort zeigen, Rest per Button aufklappen */
  function ugc(u){
    if(u.dataset.more)return;u.dataset.more=1;
    var t=u.querySelector('.lll-ugc-track');if(!t)return;var n=t.children.length;if(n<=8)return;
    var de=(document.documentElement.lang||'de').slice(0,2)==='de';
    var w=document.createElement('div');w.className='lllp-more';
    var b=document.createElement('button');b.type='button';b.className='lllp-btn lllp-btn--ghost';b.setAttribute('aria-expanded','false');
    function lab(){var o=u.classList.contains('lllp-open');b.textContent=o?(de?'Weniger anzeigen':lllT('Show less')):(de?'Alle '+n+' Kundenfotos anzeigen':lllT('Show all {n} customer photos').replace('{n}',n));b.setAttribute('aria-expanded',o)}
    b.addEventListener('click',function(){var o=u.classList.toggle('lllp-open');lab();if(!o)u.scrollIntoView({block:'start'})});
    lab();w.appendChild(b);t.parentNode.insertBefore(w,t.nextSibling);
  }

  function init(root){
    root=root||document;
    [].forEach.call(root.querySelectorAll('.lll-ugc'),ugc);
    [].forEach.call(root.querySelectorAll('img[data-lz-src]'),function(i){if(touch&&i.classList.contains('b'))return;lz.observe(i)});
    [].forEach.call(root.querySelectorAll('.lllp-h2:not(.lit)'),function(h){if(RM)h.classList.add('lit');else io.observe(h)});
    if(!RM)[].forEach.call(root.querySelectorAll('.lllp-pad:not(.rv-in):not(.rv-wait)'),function(s){var r=s.getBoundingClientRect();if(r.top>innerHeight){s.classList.add('rv-wait');io.observe(s)}});
    [].forEach.call(root.querySelectorAll('.lllp-ct,.lllp-pc'),function(c){mid.observe(c)});
    [].forEach.call(root.querySelectorAll('.lllp-pc'),tilt);
  }

  /* Lichtkegel am Mauszeiger */
  if(!RM&&matchMedia('(hover:hover) and (pointer:fine)').matches){
    var c=document.createElement('div');c.className='lllp-cursor';c.setAttribute('aria-hidden','true');
    var raf=0,x=0,y=0;
    addEventListener('pointermove',function(e){x=e.clientX;y=e.clientY;if(!raf)raf=requestAnimationFrame(function(){c.style.setProperty('--cx',x+'px');c.style.setProperty('--cy',y+'px');c.classList.add('on');raf=0})},{passive:true});
    document.addEventListener('mouseleave',function(){c.classList.remove('on')});
    (document.body?Promise.resolve():new Promise(function(r){document.addEventListener('DOMContentLoaded',r)})).then(function(){document.body.appendChild(c)});
  }

  /* Reveal: Bild waechst beim Scrollen auf volle Groesse, ohne Beschnitt */
  function rk(){[].forEach.call(document.querySelectorAll('.lllp-rev'),function(el){var r=el.getBoundingClientRect(),k=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height-innerHeight)));el.style.setProperty('--k',RM?1:k.toFixed(3))})}
  addEventListener('scroll',rk,{passive:true});addEventListener('resize',rk);

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();rk()});else{init();rk()}
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
